module.exports = __webpack_public_path__ + "static/media/baggages.68f47ae2.svg";